import { schema } from 'normalizr';

const transactionSchema = new schema.Entity('agreement');

export default transactionSchema;
